<div class="pb-5">
  <div class="grHead">
    <h2 class="boldLIght towLineHead">
          <strong><span class="f-32">Other nearest Dell Stores</span></strong>
    </h2>
  </div>
  <div>
    <div class="googleReviewSlide">
        <div class="grList1" *ngIf="storDetails && storDetails.nearestStores.length > 0">
            <div class="grItem" *ngFor="let item of storDetails.nearestStores; let i=index;">
              <div class="d-flex justify-content-between align-items-center" >
                <strong class="storeDistance">
                  <em Class="sdIcon"></em> Nearest Stores
                  <span class="store_distance" *ngIf="item.distance"> - {{ item.distance | number : '.2-2' }} Km</span>
                </strong>
                <!-- <div class="sharewrap" appShareButton>Share</div> -->
                        <span class="sharewrap" appShareButton [shareData]="{ displayName: item.displayName, formattedAddress: item.formattedAddress }">Share</span>
              </div>
              <div class="main-bx">
                <div class="lcHead">
                    <!-- <h2>
                        <a queryParamsHandling="preserve" >
                          {{item.displayName | textSpliteByHyphenPipe:'-':0}}
                            <small>{{item.storeNameS | textSpliteByHyphenPipe:'-':0}}</small>
                        </a>
                    </h2> -->
                        <h2>
                          <span queryParamsHandling="preserve" >
                               {{item.displayName | textSpliteByHyphenPipe:'-':0}}
                              <small>{{item.displayName | textSpliteByHyphenPipe:'-': 1 }}</small>
                              <span class="sr-only"> {{item.displayName | textSpliteByHyphenPipe:'-':0}} - {{item.displayName | textSpliteByHyphenPipe:'-': 1 }}</span>

                          </span><button *ngIf="item.status._key === 'TEMPORARILY_CLOSED' ? true : null" class="temp-closed  mt-md-0">Temporarily Closed</button>
                      </h2>
                    <span *ngIf="item.avg_rating != null" class="starRating">{{item.avg_rating}}</span>
                </div>

                <div class="divider-dash"></div>
                <div class="d-flex justify-content-center">
                  <a class="mt-3 botn btn-blue-outline" (click)="viewStore(item.formattedAddress)">
                    Visit Store
                  </a>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</div>
